import { IndustryConfig } from '../../../types'

export const careerTransitionsPersonalServicesConfig: IndustryConfig = {
  id: 'career-transitions-personal-services',
  name: 'Career Transitions & Personal Services',
  icon: '🎯',
  description: 'Career coaching, life transitions, and personal services focused on career transitions and family financial planning',
  
  businessTypes: [
    {
      id: 'career-coaching',
      name: 'Career Coaching & Consulting',
      description: 'Professional career coaching, resume services, and job placement assistance'
    },
    {
      id: 'life-coaching',
      name: 'Life Coaching & Transitions',
      description: 'Life coaching services for major life transitions and personal development'
    },
    {
      id: 'financial-planning',
      name: 'Personal Financial Planning',
      description: 'Financial planning services for individuals and families'
    },
    {
      id: 'personal-services',
      name: 'Personal & Family Services',
      description: 'Specialized personal services including eldercare, childcare planning, and family support'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'coaching-sessions',
      name: 'Coaching Sessions',
      description: 'Individual and group coaching sessions for career and life transitions',
      intelligenceValue: "We'll monitor coaching market trends, session pricing benchmarks, and demand patterns to help you optimize your coaching packages and pricing structure for different client segments."
    },
    {
      id: 'program-packages',
      name: 'Program Packages',
      description: 'Structured coaching programs and transformation packages',
      intelligenceValue: "We'll track program completion rates, outcome success metrics, and competitive program offerings to help you design more effective packages and improve client results."
    },
    {
      id: 'financial-planning',
      name: 'Financial Planning Services',
      description: 'Comprehensive financial planning and advisory services',
      intelligenceValue: "We'll monitor financial planning fee structures, regulatory changes, and market demand for different planning services to help you optimize your service mix and compliance strategies."
    },
    {
      id: 'workshops-seminars',
      name: 'Workshops & Seminars',
      description: 'Group workshops, seminars, and educational events',
      intelligenceValue: "We'll track workshop trends, attendance patterns, and pricing strategies to help you develop more profitable group offerings and scale your impact efficiently."
    }
  ],
  
  supplierCategories: [
    {
      id: 'professional-development',
      name: 'Professional Development',
      suppliers: ['Certification programs', 'Continuing education', 'Training providers', 'Professional associations', 'Conference attendance'],
      spendRanges: ['Under $2K', '$2K-$8K', '$8K-$25K', 'Over $25K']
    },
    {
      id: 'technology-tools',
      name: 'Technology & Tools',
      suppliers: ['Coaching software platforms', 'Scheduling systems', 'Video conferencing tools', 'Assessment tools', 'Website/marketing platforms'],
      spendRanges: ['Under $1K', '$1K-$4K', '$4K-$15K', 'Over $15K']
    },
    {
      id: 'business-services',
      name: 'Business Services',
      suppliers: ['Legal services', 'Accounting/bookkeeping', 'Insurance providers', 'Marketing services', 'Administrative support'],
      spendRanges: ['Under $2K', '$2K-$10K', '$10K-$30K', 'Over $30K']
    },
    {
      id: 'office-operations',
      name: 'Office & Operations',
      suppliers: ['Office space/coworking', 'Communication services', 'Office supplies', 'Travel expenses', 'Client materials'],
      spendRanges: ['Under $1.5K', '$1.5K-$6K', '$6K-$20K', 'Over $20K']
    }
  ],
  
  competitiveFactors: [
    'Professional credentials',
    'Success track record',
    'Specialized expertise',
    'Client testimonials',
    'Personal connection',
    'Methodology effectiveness',
    'Pricing accessibility',
    'Availability/responsiveness',
    'Industry knowledge',
    'Referral network'
  ]
}